document.addEventListener("DOMContentLoaded", addOneModalHandler);

function addOneModalHandler() {
  const addOneModalRefs = {
    modal: document.getElementById("add--one--modal"),
    openers: document.querySelectorAll(".add-one__popup-opener"),
    closeBtn: document.querySelector(
      "#add--one--modal .add--one--modal__close"
    ),
    title: document.querySelector(
      "#add--one--modal .add--one--modal__info--title"
    ),
    raiting: document.querySelector(
      "#add--one--modal .add--one--modal__info--raiting"
    ),
    description: document.querySelector(
      "#add--one--modal .add--one--modal__info--description"
    ),
    imageList: document.querySelector(
      "#add--one--modal .add--one--modal__image--list"
    ),
    paginationImageList: document.querySelector(
      "#add--one--modal .add--one--modal__image--list__pagination"
    ),
    modalHandlersBox: document.querySelector("[is-addone-modal-handlers-box]"),
    modalColorPickerBox: document.querySelector("[is-addone-modal-colors]"),
    modalVariantPickerBox: document.querySelector("[is-addone-modal-variants]"),
    modalCheckbox: document.querySelector("[is-addone-modal-checkbox]"),
  };
  const mainRefs = {
    accordionTriggers: document.querySelectorAll("[is-accordion-trigger]"),
  };

  let modalSwiper;
  let modalPaginationSlider;
  let addoneCheckboxLabel = null;

  function modalCheckboxHandle() {
 
    var currentId = $('[is-addone-modal-checkbox]').attr('data-id');
    $(addoneCheckbox).val(currentId);
    $(addoneCheckbox).attr('data-id', currentId)
    addoneCheckboxLabel.click();
    setTimeout(function(){
      closeAddOneModal();
    },200);
  }

  function closeAddOneModal() {
    toggleAddOneModal();
    addOneModalRefs.modalCheckbox.removeEventListener(
      "change",
      modalCheckboxHandle
    );

    if (modalSwiper) {
      modalSwiper.destroy();
      modalPaginationSlider.destroy();
      modalSwiper = null;
      modalPaginationSlider = null;
    }
    const tildoChat = document.getElementById("tidio-chat-iframe");
    if (tildoChat) {
      tildoChat.style.display = "block";
    }
  }

  function toggleAddOneModal() {
   
    addOneModalRefs.modal.classList.toggle("open");
    addOneModalRefs.modalHandlersBox.classList.toggle("open");
    document.body.classList.toggle("modal--open");
    const tildoChat = document.getElementById("tidio-chat-iframe");
    if (tildoChat) {
      tildoChat.style.display = "none";
    }
  }

  function onModalOpenerClick(event) {

    const addOneContainer = event.currentTarget.closest(
      ".product-single__add-one"
    );
    addoneCheckboxLabel = addOneContainer.querySelector("[is-checkbox-label]");
    addoneCheckbox = addOneContainer.querySelector("[is-checkbox-label] input");

    addOneModalRefs.modalCheckbox.checked = addoneCheckbox.checked;
    addOneModalRefs.modalCheckbox.addEventListener(
      "change",
      modalCheckboxHandle
    );

    const addOneRaiting = addOneContainer
      .querySelector(".add-one__raiting")
      .cloneNode(true);

    const colorPickers = addOneContainer.querySelectorAll(
      ".add-one__variants .add-one__options label"
    );
    const variantPickers = addOneContainer.querySelectorAll(
      ".add-one__variants .product__swatch-container label"
    );

    addOneModalRefs.modalColorPickerBox.innerHTML = "";
    addOneModalRefs.modalVariantPickerBox.innerHTML = "";

    colorPickers.forEach((label) => {
      const span = label.querySelector("span").cloneNode(true);
      const input = label.previousElementSibling;

      const colorModalLabel = document.createElement("label");
      colorModalLabel.classList.add("modal--color__label");
      if (input && input.checked) {
        colorModalLabel.classList.add("activelabel");
      }
      colorModalLabel.textContent = label.textContent;
      const colorModalinput = document.createElement("input");

      if (label.classList.contains('addone-color-label-out')) {
        colorModalLabel.classList.add("addone-color-label-out");
        colorModalinput.disabled = true;
      }
      
      colorModalinput.type = "radio";
      colorModalinput.name = "modal--color";

      colorModalLabel.appendChild(colorModalinput);
      colorModalLabel.appendChild(span);

      // if (input.checked) colorModalinput.checked = true;

      colorModalinput.addEventListener("change", (event) => {
        if (colorModalinput.classList.contains('addone-color-label-out')) {
          console.log('The span is not empty and contains an SVG.');
        } else {
          $('.product-single__add-ons').attr('data-from-popup', '1');
          console.log(label);
          label.click();
          setTimeout(function(){
            $('.product-single__add-ons').attr('data-from-popup', '0');
          },1000);
        }
        
        console.log('126');
      });

      addOneModalRefs.modalColorPickerBox.appendChild(colorModalLabel);
    });

 
  

    if (variantPickers.length > 0) {
      variantPickers.forEach((label) => {
        const input = label.previousElementSibling;

        var currentValue = label.getAttribute('data-value-handle');

        const variantModalLabel = document.createElement("label");
        variantModalLabel.classList.add("modal--variant__label");
        if (input && input.checked) {
          variantModalLabel.classList.add("activelabel");
        }
        variantModalLabel.setAttribute('data-value-handle', currentValue);

        if (label.classList.contains('addone-switcher-label-out')) {
          variantModalLabel.classList.add('addone-switcher-label-out');
        }
        variantModalLabel.textContent = label.textContent;
        const variantModalinput = document.createElement("input");
        variantModalinput.type = "radio";
        variantModalinput.name = "modal--variant";
        if (label.classList.contains('addone-switcher-label-out')) {
          variantModalinput.disabled = "disabled";
        }
        const svg = label.querySelector("svg").cloneNode(true);
        variantModalLabel.appendChild(variantModalinput);
        variantModalLabel.appendChild(svg);

        // if (input.checked) variantModalinput.checked = true;

        variantModalinput.addEventListener("change", (event) => {
          $('.product-single__add-ons').attr('data-from-popup', '1');
         
          label.click();
          // variantModalinput.click();
          setTimeout(function(){
            $('.product-single__add-ons').attr('data-from-popup', '0');
          },1000);
          console.log(label);
          console.log('147');
        });

        addOneModalRefs.modalVariantPickerBox.append(variantModalLabel);
      });
    }

    const { description, title, url, id } = addOneContainer.dataset;
    const mediaArr = window[`addOneMedia${id}`];


    // const learnMoreLink = document.createElement("a");
    // learnMoreLink.href = url;
    var buttonText = $('.pdp_variables_for_popups').attr('data-more');

    addOneModalRefs.title.innerHTML = title;
    addOneModalRefs.description.innerHTML = `${description} <a href="${url}">`+buttonText+`</a>`;
    addOneModalRefs.raiting.innerHTML = "";
    addOneModalRefs.imageList.innerHTML = "";
    addOneModalRefs.paginationImageList.innerHTML = "";
    addOneModalRefs.raiting.appendChild(addOneRaiting);


    var variantImageSource = $('.addOneVariantSelection.activeVariant[data-product-id="'+id+'"]').attr('data-src');
  
    const customSlideElem = $('<li class="swiper-slide"></li>');
    const customSlideImg = $('<img />', {
      class: 'variantImage__js-addone',
      src: variantImageSource, 
      alt: 'Variant image'  
    });
      
  
    customSlideElem.append(customSlideImg);
    

    // Prepend the custom slide to both the image list and the pagination image list
    $(addOneModalRefs.imageList).prepend(customSlideElem);
    $(addOneModalRefs.paginationImageList).prepend(customSlideElem.clone());


    mediaArr.map((item) => {
      const slideElem = document.createElement("li");
      const slideImg = document.createElement("img");
      slideElem.classList.add("swiper-slide");

      slideImg.src = item.preview_image.src;
      slideImg.alt = title;

      slideElem.appendChild(slideImg);

      const copyOfSlideElem = slideElem.cloneNode(true);
      addOneModalRefs.imageList.appendChild(slideElem);
      addOneModalRefs.paginationImageList.appendChild(copyOfSlideElem);
    });

    modalPaginationSlider = new Swiper(
      "#add--one--modal__image--slider_pagination",
      {
        loop: false,
        slidesPerView: "auto",
        spaceBetween: 7,
        allowTouchMove: true,
        navigation: {
          nextEl: ".modal--slider--next",
          prevEl: ".modal--slider--prev",
        },
      }
    );

    modalSwiper = new Swiper("#add--one--modal__image--slider", {
      loop: false,
      navigation: {
        nextEl: ".modal--slider--next",
        prevEl: ".modal--slider--prev",
      },
      thumbs: {
        swiper: modalPaginationSlider,
      },
    });

    // $('.modal--color__label').click(function(){
    //   modalSwiper.slideTo(0, 0, false);
    // });

    $('.add--one--modal__handlers').click(function(){
      modalSwiper.slideTo(0, 0, false);
      $('.add--one--modal').scrollTop(0);
    });

    

    toggleAddOneModal();
  }

  addOneModalRefs.modal.addEventListener("click", (event) => {
    if (event.target === event.currentTarget) {
      closeAddOneModal();
      // alert('214');
    }
  });
  addOneModalRefs.closeBtn.addEventListener("click", closeAddOneModal);

  // addOneModalRefs.openers.forEach((opener) => {
  //   opener.addEventListener("click", onModalOpenerClick);
  //   var currentId = $(this).attr('data-product-id');
  //   $('.add--one--modal__content').attr('data-product-id', currentId);
  // });

  addOneModalRefs.openers.forEach((opener) => {
      opener.addEventListener("click", function (event) {
        onModalOpenerClick(event);

          var currentId = $(this).attr('data-product-id');
          $('.add--one--modal__content').attr('data-product-id', currentId);
      });
  });
}
